import React from 'react';
import './LoadingSpinner.css';

interface LoadingSpinnerProps {
  size?: 'small' | 'medium' | 'large';
  color?: 'primary' | 'secondary' | 'white';
  className?: string;
}

export function LoadingSpinner({ 
  size = 'medium', 
  color = 'primary',
  className = '' 
}: LoadingSpinnerProps) {
  return (
    <div className={`loading-ring ${size} ${color} ${className}`}>
      <div className="ring"></div>
      <div className="ring"></div>
      <div className="ring"></div>
    </div>
  );
} 